import { useQuery } from '@tanstack/react-query';

import UsersService from '~/services/UsersService';

export const usersByIdsQueryKeys = {
  all: ['users-by-ids'] as const,
  list: (brand: string, userIds: Array<string>) => [...usersByIdsQueryKeys.all, brand, ...userIds] as const,
};

type UserRecord = Record<string, unknown>;

type Params = {
  brand: string;
  userIds: Array<string>;
  enabled?: boolean;
};

export function useUsersByIds({ brand, userIds, enabled = true }: Params) {
  return useQuery({
    queryFn: async ({ signal }): Promise<Array<UserRecord>> => {
      if (userIds.length === 0) {
        return [];
      }

      const response = await UsersService.getUsers(
        {
          filter: userIds.join(','),
          limit: userIds.length,
          brand,
        },
        { signal },
      );

      return (response ?? []) as Array<UserRecord>;
    },
    queryKey: usersByIdsQueryKeys.list(brand, userIds),
    enabled: enabled && !!brand && userIds.length > 0,
  });
}
